import Box from '@mui/material/Box';
import { useFetchTeamsQuery } from '../../store/team/TeamApi';
import { CircularProgress, Paper, Typography, Stack } from '@mui/material';
import { useParams } from 'react-router';
//import { useTheme } from '@mui/material/styles';
import GroupsIcon from '@mui/icons-material/Groups';
import PeopleIcon from '@mui/icons-material/People';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import HotelIcon from '@mui/icons-material/Hotel';
import { myConstants } from '../../shares/Constants';


/*
 * erzeugt ein status-tile
 */
function StatTile({ icon, value, label, sub }) {
  //const theme = useTheme();
  return (
    <Paper 
      elevantion = {3} 
      sx= {{ 
        p: 2, 
        borderRadius: 2, 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        textAlign: 'center',
        gap: 0.5, 
        height: '100%',
        borderTop: '3px solid',
        borderTopColor: 'primary.main',
       }}
    >
      <Box sx={{
        color: 'primary.main',
        display: 'flex',
      }}>
        {icon}
      </Box>
      <Stack spacing={0.25} alignItems="center">
        <Typography variant="h5" fontWeight={700} lineHeight={1} color="primary.dark">
          {value}
        </Typography>
        <Typography variant="caption" fontWeight={500} display="block">
          {label}
        </Typography>
        {sub && (
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }} display="block">
            {sub}
          </Typography>
        )}
      </Stack>
    </Paper>
  );
};




export default function TeamOverview() {

  const { clubLabel, year: selectedYear } = useParams();

  const { data: teams, isLoading } = useFetchTeamsQuery({
    year: selectedYear,
    clubLabel,
  });

  if (isLoading) return <CircularProgress />;
  if (!teams?.length) return null;

  // Aus den Teams jene heraussuchen, die registriert sind
  const registered = teams.filter(
    team => ( team.status ?? myConstants.teamModel.status.registered) === myConstants.teamModel.status.registered
  );

  // Jene Teams herauslesen, die auf der Warteliste stehen
  const waitlisted = teams.filter(
    team => ( team.status ?? myConstants.teamModel.status.waitlist) === myConstants.teamModel.status.waitlist
  );

  // Anzahl der Teams pro Spielklasse ermitteln - dient nur der Übersicht
  const wu8 = registered.filter(t => t.is_female === true  && t.is_u8 === true ).length;
  const wu10 = registered.filter(t => t.is_female === true  && t.is_u8 === false).length;
  const mu8  = registered.filter(t => t.is_female === false && t.is_u8 === true ).length;
  const mu10 = registered.filter(t => t.is_female === false && t.is_u8 === false).length;

  // Anzahl aller Spieler (ohne die auf der Warteliste)
  const totalPlayers  = registered.reduce((sum, team) => sum + (team.players ?? 0), 0);

  // Anzahl aller begleitenden Personen (wieder ohne die Teams der Warteliste)
  const totalFellows  = registered.reduce((sum, team) => sum + (team.fellows ?? 0), 0);

  // Anzahl aller Frühstücke am Samstag, Sonntag und Essem am Samstag abend 
  const totalSaturdayBreakfast  = registered.reduce((sum, team) => sum + (team.saturdayBreakfast ?? 0), 0);
  const totalSundayBreakfast    = registered.reduce((sum, team) => sum + (team.sundayBreakfast ?? 0), 0);
  const totalSaturdayLunch      = registered.reduce((sum, team) => sum + (team.saturdayLunch ?? 0), 0 );
  const totalMeals              = totalSaturdayBreakfast + totalSaturdayLunch + totalSundayBreakfast;

  // Anzahl der Personen im Shuttle
  const totalShuttle  = registered.reduce(
    (sum, team) => sum + (team.shuttleArrivingCount ?? 0) + (team.shuttleDepartingCount ?? 0), 0
  );

  // Anzahl der Teams, die (registriert sind) übernachten wollen
  const totalOvernight = registered.filter(
    team => team.vacationType === myConstants.overnight
  ).length;
    
  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      gap: 2,
      mb: 2,
    }}>
      <StatTile
        icon={<GroupsIcon />}
        value={registered.length}
        label="Teams"
        sub={<> 
          {wu8  > 0 && <>{wu8} wU8<br /></>}
          {wu10 > 0 && <>{wu10} wU10<br /></>}
          {mu8  > 0 && <>{mu8} mU8<br /></>}
          {mu10 > 0 && <>{mu10} mU10<br /></>}
          {waitlisted.length > 0 && <>+ {waitlisted.length} auf Warteliste</>}          
        </>}
      />

      <StatTile
        icon={<PeopleIcon />}
        value={totalPlayers + totalFellows}
        label="Personen gesamt"
        sub={<>{totalPlayers} SpielerInnen <br/> {totalFellows} Mitreisende </>}
      />

      <StatTile
        icon={<HotelIcon />}
        value={totalOvernight}
        label="Übernachtungen"
        sub={`von ${registered.length} Teams`}
      />

      <StatTile
        icon={<RestaurantIcon />}
        value={totalMeals}
        label="Mahlzeiten"
        sub={<>
            { totalSaturdayBreakfast > 0 && <> {totalSaturdayBreakfast} Frühstück Sa.<br /> </> }
            { totalSaturdayLunch > 0 && <> {totalSaturdayLunch} Abendessen Sa.<br /></> }
            { totalSundayBreakfast > 0 && <> {totalSundayBreakfast} Frühstück So.</> }
        </>}
      />

      <StatTile
        icon={<DirectionsBusIcon />}
        value={totalShuttle}
        label="Shuttle-Plaetze"
      />
    </Box>
  );
}